/**
 * ehr#731 (NO_SHOW_CANCELLATION_NOTE_10-29-V4, with Jay's 10-30 answers on ehr#713): the no-show /
 * cancellation note's own rules, shared by the editor, the sign-off check and the API.
 *
 *  - The Contact note must be written (#713 Q3, "make it mandatory"). An absent group or family
 *    member's note, which is written on the no-show layout, keeps it optional: those notes belong
 *    to the group and family note pages.
 *  - Two Flags after the Contact note: Risk concern and Leading to discharge (#713 Q1).
 *  - An associate's no-show note goes to their supervisor only when the practice turns that on
 *    (Practice note settings, Off by default) or when a flag is ticked (#713 Q1).
 *  - When a visit is marked No-show or Late cancel in the Calendar, the EHR starts the note as a
 *    draft for the clinician, with a notice (#713 Q4; the API's no-show-start scan).
 */
export const NO_SHOW_KIND = 'No-show / cancellation';
/** The Flags part's id: its ticked items are kept in body.extras like any layout checklist. */
export const NO_SHOW_FLAGS_ID = 'noShowFlags';
export const NO_SHOW_FLAGS_LABEL = 'Flags';
export const NO_SHOW_RISK = 'Risk concern';
export const NO_SHOW_DISCHARGE = 'Leading to discharge';
export const NO_SHOW_FLAGS = [NO_SHOW_RISK, NO_SHOW_DISCHARGE];
/** The Calendar statuses that start a no-show note (calendar STATUS_KEYS "no-show", "late-cancel"). */
export const NO_SHOW_CALENDAR_STATUSES = ['no-show', 'late-cancel'];
/** The flags ticked on a saved note body (body.extras.noShowFlags), in the Flags order. */
export function noShowFlagsOf(body) {
    const extras = body && typeof body === 'object' ? body.extras : undefined;
    const v = extras && typeof extras === 'object'
        ? extras[NO_SHOW_FLAGS_ID]
        : undefined;
    const on = Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
    return NO_SHOW_FLAGS.filter((f) => on.includes(f));
}
/**
 * Whether a note by a clinician whose notes need a co-signature (Supervision on: V141's associate)
 * goes to their supervisor. Every note does, as before, except a no-show / cancellation note
 * (not an absent member's), which goes only when the practice asks for supervisor sign-off on
 * them, when Risk concern or Leading to discharge is ticked, or when it is already in the review
 * loop (sent back, so the resubmit returns to the supervisor).
 */
export function supervisorReviews(o) {
    if (o.kind !== NO_SHOW_KIND || o.absentMember || o.sessionNote)
        return true;
    return o.returned === true || o.noShowSignoff || o.flags.length > 0;
}
//# sourceMappingURL=noShowNote.js.map